import AmexShopSmall, { ComponentAmexShopSmallUnderTest } from './AmexShopSmall';

export default AmexShopSmall;

export {
  ComponentAmexShopSmallUnderTest,
};
